<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="65"
    height="64"
    viewBox="0 0 65 64"
    fill="none"
  >
    <path
      d="M27.584 15H38.6985M60.5 27.4919V33.8762M4.5 27.4919V33.8762M24.5916 28.7687V31.7481L27.584 37.2812L30.5763 31.7481V28.7687M33.9962 37.7069V33.8762M37.8435 33.8762C38.6985 33.8762 40.4084 33.3655 40.4084 31.3225C40.4084 29.2795 38.6985 28.7687 37.8435 28.7687H33.9962V33.8762M37.8435 33.8762H33.9962M37.8435 33.8762L39.9809 37.7069M10.0573 21.5335C17.0394 19.4053 35.7916 16.426 54.9427 21.5335C56.2252 22.3844 57.5076 23.7464 57.5076 29.1944C57.5076 34.6424 57.5076 38.2744 57.5076 39.4093C57.5076 42.3887 53.5748 48.2623 37.8435 47.9218L32.2863 41.9631L26.729 47.9218C20.3168 48.3475 7.49237 47.2408 7.49237 39.4093C7.49237 38.2744 7.49237 34.6424 7.49237 29.1944C7.49237 23.7464 9.20229 21.8171 10.0573 21.5335Z"
      stroke="white"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
